module.exports = __webpack_public_path__ + "img/img8.75aa4daa.svg";